




















import { Component, Emit, Vue } from 'vue-property-decorator';
import { vxm } from '@/store';
import { MinimizedTask } from '@/@types/Task';

@Component
export default class TaskMinimizedList extends Vue {
  private get projectId() {
    return vxm.theoryApi.authStore.getCurrentProjectId;
  }

  private get projectName() {
    const response = vxm.theoryApi.projectsStore.getProject;
    if (response) {
      return response.results.projectName;
    } else {
      return null;
    }
  }

  private get minimizedTaskList() {
    return vxm.theoryApi.tasksStore.getMinimizedTaskList;
  }

  /**
   * 選択
   */
  @Emit('select')
  private async select(task: MinimizedTask): Promise<void> {
    if (this.projectId) {
      await vxm.theoryApi.tasksStore.fetchTask({
        taskId: task.taskId,
        query: {
          'project-id': this.projectId,
        },
      });
    }
    // 最小化リストからタスクの削除
    vxm.theoryApi.tasksStore.removeMinimizedTask(task);
  }
}
